import { UserInteractionTypes } from '../../../common/store/store.types';
import {
  ACTION_USER_INTERACTION,
} from '../../../common/store/store.actions';

export const setUserInteraction = (interaction: UserInteractionTypes) => (dispatch): void => {
  dispatch({ type: ACTION_USER_INTERACTION, payload: interaction });
};
